import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vintus.webp';
import screenshot_target from '../../../images/letterfunnel/henkluitjes.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Henk Luitjes"
      firstname="Henk"
      companyname="Vintus"
      competition="Infi en Luminis"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/henkluitjes.js